module.exports = __webpack_public_path__ + "static/img/2.4b6f9d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/2.png
// module id = uXeY
// module chunks = 0